import type { SemanticEvent } from '../../../types/analyticstypes';
import { formatRelativeTime } from '../../../utils/analytics/format';

function fmtVal(v: unknown): string {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  if (typeof v === 'number') return String(v);
  if (typeof v === 'string') return v.length > 40 ? v.slice(0, 37) + '…' : v;
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}

const HIDE_KEYS = new Set(['sessionTimeMs', 'sessionId']);

export default function JourneyEventRow({
  event,
  sessionStartTs,
  highlightColor,
}: {
  event: SemanticEvent;
  sessionStartTs: number;
  highlightColor?: string;
}) {
  const entries = event.data
    ? Object.entries(event.data).filter(([k]) => !HIDE_KEYS.has(k))
    : [];
  return (
    <div className="flex items-start gap-3 py-1.5 px-2 hover:bg-gray-50 rounded text-xs">
      <span className="text-gray-400 font-mono w-12 shrink-0">
        {formatRelativeTime(event.ts, sessionStartTs)}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className={`font-medium ${highlightColor || 'text-gray-800'}`}>
            {event.type}
          </span>
          <span className="text-gray-400 text-[10px]">{event.route}</span>
        </div>
        {entries.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-1">
            {entries.map(([k, v]) => (
              <span
                key={k}
                className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-gray-100 rounded text-[10px]"
                title={`${k}: ${fmtVal(v)}`}
              >
                <span className="text-gray-500">{k}</span>
                <span className="font-mono text-gray-700">{fmtVal(v)}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
